import React from 'react';
import {Form, Edit, Suggestions, Flex, List} from 'components';
import {useNamedSelector} from 'helpers';

export function BeliefsInquiry1() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'beliefs-inquiry-1' })}>
      <List tiny-gutter>
        <List.Title>Before you can transform your beliefs, you need to become aware of them. On this page, you'll uncover both the negative and positive beliefs you hold.</List.Title>
        <List.Title>What are your most negative beliefs about yourself?</List.Title>
        <Flex even stack>
          <Edit name="1" Suggestions={Suggestions.NegativeBeliefs} />
          <Edit name="2" Suggestions={Suggestions.NegativeBeliefs} />
          <Edit name="3" Suggestions={Suggestions.NegativeBeliefs} />
        </Flex>
        <List.Title>What are your biggest obstacles to success?</List.Title>
        <Flex even stack>
          <Edit name="4" Suggestions={Suggestions.Obstacles} />
          <Edit name="5" Suggestions={Suggestions.Obstacles} />
          <Edit name="6" Suggestions={Suggestions.Obstacles} />
        </Flex>
        <List.Title>What are your greatest weaknesses?</List.Title>
        <Flex even stack>
          <Edit name="7" />
          <Edit name="8" />
          <Edit name="9" />
        </Flex>
        <List.Title>What are your most frequent negative emotions?</List.Title>
        <Flex even stack>
          <Edit name="10" Suggestions={Suggestions.NegativeEmotions} />
          <Edit name="11" Suggestions={Suggestions.NegativeEmotions} />
          <Edit name="12" Suggestions={Suggestions.NegativeEmotions} />
        </Flex>
        <List.Title>What do you often feel guilty about?</List.Title>
        <Edit name="13" />
        <List.Title>What is your most common excuse?</List.Title>
        <Edit name="14" />
        <List.Title>What is your biggest problem or source of negativity in life today?</List.Title>
        <Edit name="15" />
        <List.Title>Identify the self-limiting beliefs that could be holding you back:</List.Title>
        <Edit name="16" />
        <Edit name="17" />
        <Edit name="18" />
      </List>
    </Form>
  );
}
